/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Dialog, InlineNotification, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/slack-account-link';

const styles = {
  notification: css`
    margin-top: var(--cds-spacing-150);
  `,
};

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
  loading?: boolean;
  error?: boolean;
};

export const UnlinkSlackConfirm = ({ onCancel, onConfirm, loading, error }: Props) => {
  return (
    <React.Fragment>
      <Dialog.HeadingGroup>{_t('Unlink Slack from Coursera')}</Dialog.HeadingGroup>
      <Dialog.Content id="dialog-content">
        <Typography2 component="p">
          {_t('If you unlink your email, learners can no longer find your Slack account on Coursera.')}
        </Typography2>
        <div role="alert" aria-live="assertive" aria-atomic="true">
          {error && (
            <InlineNotification severity="error" css={styles.notification}>
              {_t('Something went wrong. Please try again.')}
            </InlineNotification>
          )}
        </div>
      </Dialog.Content>
      <Dialog.Actions>
        <Button variant="secondary" onClick={onCancel} style={{ marginRight: 12 }}>
          {_t('Cancel')}
        </Button>
        <Button data-testid="unlink-confirm-button" variant="primary" loading={loading} onClick={onConfirm}>
          {_t('Unlink')}
        </Button>
      </Dialog.Actions>
    </React.Fragment>
  );
};

export default UnlinkSlackConfirm;
